




































































import Vue from "vue";
import NavigationButton from "@/components/navigation-button/NavigationButton.vue";

export default Vue.extend({
  name: "Navigation",
  components: {
    NavigationButton
  },
  data() {
    return {
      showMenu: false,
      showNavbar: true,
      lastScrollPosition: 0,
      routes: [
        {
          link: "/home",
          name: "Home"
        },
        {
          link: "/platforms",
          name: "Platforms"
        },
        {
          link: "/news",
          name: "News"
        },
        {
          link: "/team",
          name: "Team"
        },
        {
          link: "/pipeline",
          name: "Pipeline"
        },
        {
          link: "/publications",
          name: "Publications"
        },
        {
          link: "/careers",
          name: "Careers"
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollY);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollY);
  },
  methods: {
    toggleShowMenu() {
      this.showMenu = !this.showMenu;
    },
    routeChanged(route: any) {
      this.showMenu = false;
    },
    scrollY() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop|| document.body.scrollTop;

      if (currentScrollPosition < 0) {
        return;
      }

      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    navigateToHome() {
      if (this.$router.currentRoute.name === "home") return;
      this.$router.push("home");
    }
  }
});
